import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { TabBar } from '@inmoment/the-kitchen';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

export const data1 = ['Example', 'ToolTipProps', 'ClockDirection'].map(convertArrayToTabBar);

export const IconButtonDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('Example');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <div>
      <p className="kxi-text-300 kxi-text-normal">IconButton Tooltip</p>
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'Example' && (
        <CodeBlock
          hasTopRadius={false}
          code={`{
  direction: 6;
  text: "Whoo tooltip!";
}`}
        />
      )}
      {tab === 'ToolTipProps' && (
        <CodeBlock
          hasTopRadius={false}
          code={`export interface ToolTipProps {
  direction?: ClockDirection;
  isOpenOnClick?: boolean;
  text: string;
  maxWidth?: number;
}`}
        />
      )}

      {tab === 'ClockDirection' && (
        <CodeBlock
          hasTopRadius={false}
          code={`// Positioned like a clock
//   11 12 1
// 10    /   2
//  9   . _  3
//  8        4
//   7  6  5

export type ClockDirection = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;`}
        />
      )}
      <div style={{ display: 'flex' }}>
        <div
          style={{
            display: 'flex',
            padding: 24,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={'/iconbutton_tooltip.gif'} width={442} height={196} alt="iconbutton-tooltip" />
        </div>
      </div>
      <br />
    </div>
  );
};
